import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrderCompaniesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrderCompaniesQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly id: string, readonly companies: ReadonlyArray<{ readonly __typename?: 'AccountsCompany', readonly id: string, readonly name: string }> } | null };

export type OrderReportStatusQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type OrderReportStatusQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly id: string, readonly projectReport?: { readonly __typename?: 'ProjectReport', readonly id: string, readonly status: Types.ProjectReportStatus, readonly errorReason?: Types.ProjectReportErrorReason | null } | null } | null };


export const OrderCompaniesDocument = gql`
    query OrderCompanies {
  currentUser {
    id
    companies {
      id
      name
    }
  }
}
    `;

/**
 * __useOrderCompaniesQuery__
 *
 * To run a query within a React component, call `useOrderCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<OrderCompaniesQueryPage, OrderCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderCompaniesQueryPage, OrderCompaniesQueryVariables>(OrderCompaniesDocument, options);
      }
export function useOrderCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderCompaniesQueryPage, OrderCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderCompaniesQueryPage, OrderCompaniesQueryVariables>(OrderCompaniesDocument, options);
        }
export function useOrderCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderCompaniesQueryPage, OrderCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderCompaniesQueryPage, OrderCompaniesQueryVariables>(OrderCompaniesDocument, options);
        }
export type OrderCompaniesQueryHookResult = ReturnType<typeof useOrderCompaniesQuery>;
export type OrderCompaniesLazyQueryHookResult = ReturnType<typeof useOrderCompaniesLazyQuery>;
export type OrderCompaniesSuspenseQueryHookResult = ReturnType<typeof useOrderCompaniesSuspenseQuery>;
export type OrderCompaniesQueryResult = Apollo.QueryResult<OrderCompaniesQueryPage, OrderCompaniesQueryVariables>;
export const OrderReportStatusDocument = gql`
    query OrderReportStatus($id: ID!) {
  currentUser {
    id
    projectReport(id: $id) {
      id
      status
      errorReason
    }
  }
}
    `;

/**
 * __useOrderReportStatusQuery__
 *
 * To run a query within a React component, call `useOrderReportStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderReportStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderReportStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderReportStatusQuery(baseOptions: Apollo.QueryHookOptions<OrderReportStatusQueryPage, OrderReportStatusQueryVariables> & ({ variables: OrderReportStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderReportStatusQueryPage, OrderReportStatusQueryVariables>(OrderReportStatusDocument, options);
      }
export function useOrderReportStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderReportStatusQueryPage, OrderReportStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderReportStatusQueryPage, OrderReportStatusQueryVariables>(OrderReportStatusDocument, options);
        }
export function useOrderReportStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderReportStatusQueryPage, OrderReportStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderReportStatusQueryPage, OrderReportStatusQueryVariables>(OrderReportStatusDocument, options);
        }
export type OrderReportStatusQueryHookResult = ReturnType<typeof useOrderReportStatusQuery>;
export type OrderReportStatusLazyQueryHookResult = ReturnType<typeof useOrderReportStatusLazyQuery>;
export type OrderReportStatusSuspenseQueryHookResult = ReturnType<typeof useOrderReportStatusSuspenseQuery>;
export type OrderReportStatusQueryResult = Apollo.QueryResult<OrderReportStatusQueryPage, OrderReportStatusQueryVariables>;